import React from "react";
import { ServicesFooter } from "./services-footer"

/**
 * Componente para mostrar el servicio análisis de datos.
 *
 * @component
 * 
 */

export const AnalisisDatos = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

  return (
    <div id="service-detail" className="text-center">
        <div className="col-md-8 col-md-offset-2 section-title">
            <h2><span className="title">Servicios</span></h2>
        </div>
        <div className="col-md-12 imgMain paddingRightLeft0 text-right">
                <span>
                    <img alt="Analisis De Datos" src={width < breakpoint ? "/img/services/AnalisisDeDatos/AnalisisdeDatos_img1_mob.webp" : "/img/services/AnalisisDeDatos/AnalisisdeDatos_img1.webp"}></img>
                </span>
            <div className="text-left titleService">
                <p>Análisis<br></br> de Datos</p>
            </div>
        </div>
        <div className="col-md-12 col-xs-12">
            <div className={width < breakpoint ? "col-md-12 col-xs-12 paddingRightLeft0" : "col-md-12 col-xs-12"}>
                <div className="paddingRightLeft0 paddingTopBottom8 text-analisisdato-img1 text-left">
                    <span>En un mundo cada vez más impulsado por los datos, entendemos la importancia de atribuir correctamente el valor a tus esfuerzos de marketing. Nuestro enfoque de Media Attribution y Data Driven se basa en el análisis exhaustivo de los datos para identificar las tácticas y estrategias más efectivas.</span>
                </div>
            </div>
        </div>
        <div className="container-fluid padding-fluid">
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-1">&nbsp;</div>
                </div>
                <div className="col-md-12">
                    <div className="col-md-12 col-xs-12">
                        <div className={width < breakpoint ? "col-md-7 col-xs-12 text-left text-analisisdato-1 paddingRightLeft0" : "col-md-7 col-xs-12 text-left text-analisisdato-1"}>
                            <p>Creamos modelos de atribución en estrecha colaboración con nuestros clientes para visualizar la conexión entre la inversión en medios y los resultados comerciales.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-xs-12">
                    <div className="col-md-1 col-xs-1">&nbsp;</div>
                </div>
            </div>
        </div>
                {width < breakpoint ?
                    <img alt="Analisis De Datos" src="/img/services/AnalisisDeDatos/AnalisisdeDatos_img2.webp"></img> : ''
                }
        <div className="container-fluid padding-fluid">
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <div className={width < breakpoint ? "col-md-12 col-xs-12 paddingRightLeft0" : "col-md-12 col-xs-12" }>
                        <div className={width < breakpoint ? "col-md-12 col-xs-12 paddingRightLeft0" : "col-md-12 col-xs-12" }>
                            <div className="col-md-1 col-xs-1"></div>
                            {width < breakpoint ? '' :
                            <div className="col-md-6 col-xs-12">
                                <img alt="Analisis De Datos" src="/img/services/AnalisisDeDatos/AnalisisdeDatos_img2.webp"></img>
                            </div>}
                            
                            <div className="col-md-3 col-xs-12 text-left text-analisisdato-img2">
                                <span>Desde un pensamiento ágil y de permanente optimización, diseñamos modelos de atribución que entienden la relación entre la inversión integral a los medios y los resultados del negocio.</span>
                            </div>
                            
                        </div>
                        <div className={width < breakpoint ? "col-md-12 col-xs-12 text-left paddingTopBottom16 paddingRightLeft0" : "col-md-12 col-xs-12 text-left paddingTopBottom16" }>
                            <div className="col-md-4"></div>
                            <div className="col-md-12 col-xs-12 paddingRightLeft0">
                                <div className="col-md-7 col-md-offset-3 paddingTopBottom16">
                                    <p>Data Modeling Suite (DMS) es nuestra herramienta integral para alcanzar la efectividad.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {width < breakpoint ?
                <div className="col-md-12">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <div className="col-md-2"></div>
                            <div className="col-md-6 col-xs-11 col-xs-offset-1 paddingRightLeft0">
                                <img alt="Analisis De Datos" src="/img/services/AnalisisDeDatos/AnalisisdeDatos_img3.webp"></img>
                            </div>
                            <div className="col-md-3 col-xs-10 col-xs-offset-2 text-right text-analisisdato-img2 paddingRightLeft0">
                                <span>Exploramos diversas fuentes de datos, evaluamos patrones relevantes y establecemos relaciones clave entre atributos. A través de técnicas avanzadas de análisis, cuantificamos el impacto de las acciones de tu marca, descubrimos oportunidades, optimizamos presupuestos y tomamos decisiones informadas.</span>
                            </div>
                        </div>
                    </div>
                </div>
                : 
                <div className="col-md-12">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <div className="col-md-2"></div>
                            <div className="col-md-3 col-xs-12 text-right text-analisisdato-img2">
                                <span>Exploramos diversas fuentes de datos, evaluamos patrones relevantes y establecemos relaciones clave entre atributos. A través de técnicas avanzadas de análisis, cuantificamos el impacto de las acciones de tu marca, descubrimos oportunidades, optimizamos presupuestos y tomamos decisiones informadas.</span>
                            </div>
                            <div className="col-md-6 col-xs-12">
                                <img alt="Analisis De Datos" src="/img/services/AnalisisDeDatos/AnalisisdeDatos_img3.webp"></img>
                            </div>
                        </div>
                    </div>
                </div>
                }
                
            </div>
            {width < breakpoint ? '' :
            <ServicesFooter data={props.data} id={2} />}
        </div>
    </div>
  );
};
